import React, { useState, useEffect } from "react";
import axios from "axios";
import './Feedbackform.css';
import Select from 'react-select';
const Feedbackform = () => {
  const [formData, setFormData] = useState({
    profileId: '',
    interviewerName: '',
    interviewerMarks: '',
    remarks: '',
    status: ''
  });
  const [jobOpenings, setJobOpenings] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
const [submittedProfileIds, setSubmittedProfileIds] = useState([]);

  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [profileId, setProfileId] = useState(null); // Track selected profileId
  const [profileName, setProfileName] = useState(null);
  const [profiles, setProfiles] = useState([]); // State to store profiles
  const skillsList = ["Node", "Java", "React", "JavaScript"];
const [formErrors, setFormErrors] = useState({});
const [isJobFocused, setIsJobFocused] = useState(false);
const [isProfileFocused, setIsProfileFocused] = useState(false);
const [IsStatusFocused,setIsStatusFocused] = useState(false);
const isJobLabelFloated = isJobFocused || !!selectedJob;
const isProfileLabelFloated = isProfileFocused || !!profileId;
const isStatusFloated = IsStatusFocused || !!formData.status;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSkillChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedSkills(prev => [...prev, { skillName: value.toLowerCase(), rating: 1 }]);
    } else {
      setSelectedSkills(prev => prev.filter(skill => skill.skillName !== value.toLowerCase()));
    }
  };

  const handleRatingChange = (skillName, rating) => {
    setSelectedSkills(prev =>
      prev.map(skill =>
        skill.skillName === skillName
          ? { ...skill, rating: parseInt(rating) }
          : skill
      )
    );
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    ...formData,
    jobId: selectedJob?.jobId,
    positionName: selectedJob?.positionName,
    interviewerMarks: parseInt(formData.interviewerMarks),
    skillRatings: selectedSkills
  };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/feedback`, payload);
    alert("Feedback submitted successfully", response.data);

    // ✅ Add this line to track submitted profile
    setSubmittedProfileIds(prev => [...prev, formData.profileId]);

    // ✅ Filter the profile out of visible list
    setProfiles(prevProfiles =>
      prevProfiles.filter(profile => profile.profileId !== formData.profileId)
    );

    // Reset form
    setFormData({
      profileId: '',
      interviewerName: '',
      interviewerMarks: '',
      remarks: '',
      status: ''
    });
    setSelectedSkills([]);
    setSelectedJob(null);
    setSelectedStatus(null);
    setProfileId(null);
    setProfileName(null);

  } catch (error) {
    console.error("Error submitting feedback", error);
  }
};



  const isFormValid = () => {
    return (
      // formData.profileId.trim() !== '' &&
      // formData.interviewerName.trim() !== '' &&
      formData.interviewerMarks.trim() !== '' &&
      !isNaN(formData.interviewerMarks) &&
      Number(formData.interviewerMarks) > 0 &&
      formData.status.trim() !== '' &&
      selectedSkills.length > 0
    );
  };

  const handleJobChange = (selectedOption) => {
    if (selectedOption) {
      const job = jobOpenings.find(j => j.jobId === selectedOption.value);
      setSelectedJob(job);
      setFormData(prev => ({
        ...prev,
        positionName: job?.positionName || '',
      }));
    } else {
      setSelectedJob(null);
      setFormData(prev => ({ ...prev, positionName: '' }));
    }
  };


  const fetchAllJobs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings`);
      setJobOpenings(response.data); // Store the response data in state
    } catch (error) {
      console.error("Error fetching job openings:", error);
    }
  };

  const profileIdBasedOnJobId = async (jobId) => {
  if (!jobId) return;
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/shortlist/by-job-approved/${jobId}`);
    const filteredProfiles = response.data.filter(profile => !submittedProfileIds.includes(profile.profileId));
    setProfiles(filteredProfiles);
  } catch (error) {
    console.error("Error fetching profiles by jobId:", error);
  }
};


  useEffect(() => {
    if (selectedJob?.jobId) {
      profileIdBasedOnJobId(selectedJob.jobId);
    }
  }, [selectedJob]);



  useEffect(() => {
    fetchAllJobs(); // Fetch all job openings when the component mounts
  }, []);



  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setFormData(prev => ({
      ...prev,
      status: selectedOption ? selectedOption.value : ''
    }));
  };


  const handleProfileChange = (selectedOption) => {
    if (selectedOption) {
      const { value: id, profile } = selectedOption;
      const name = profile?.name || '';

      setProfileId(id);
      setProfileName(name);
      setFormData(prev => ({
        ...prev,
        profileId: id,
        interviewerName: profile?.interviewerName || '',
        name: name, // ✅ Make sure this is present
      }));
    }
  };




  const statusOptions = [
    { id: 1, value: 'Approved', label: 'Approved' },
    { id: 2, value: 'Rejected', label: 'Rejected' }
  ];
  return (
    <div className="feedbackform-main">
      <h3 className="feedbackform-heading">Interviewer Feedback</h3>
      <form onSubmit={handleSubmit} className="feedbackform-content">
        <div className="feedbackform-input-label-content-select">
  <label className={`did-floating-label-select ${isJobLabelFloated ? 'label-float-select' : ''}`}>
    Job ID
  </label>
  <Select
    placeholder=" "
    options={jobOpenings.map((job) => ({
      value: job.jobId,
      label: `${job.jobId} - ${job.positionName}`
    }))}
    onChange={handleJobChange}
    value={
      selectedJob
        ? { value: selectedJob.jobId, label: `${selectedJob.jobId} - ${selectedJob.positionName}` }
        : null
    }
    onFocus={() => setIsJobFocused(true)}
    onBlur={() => setIsJobFocused(false)}
    classNamePrefix="react-select"
    isClearable
  />
</div>
        <div className="feedbackform-input-label-content-select">
  <label className={`did-floating-label-select ${isProfileLabelFloated ? 'label-float-select' : ''}`}>
    Profile ID
  </label>
  <Select
    placeholder=" "
    options={profiles.map((profile) => ({
      value: profile.profileId,
      label: `${profile.profileId} - ${profile.name}`,
      profile
    }))}
    onChange={handleProfileChange}
    value={
      profiles.find((p) => p.profileId === profileId)
        ? {
            value: profileId,
            label: `${profileId} - ${profileName}`,
            profile: profiles.find((p) => p.profileId === profileId)
          }
        : null
    }
    onFocus={() => setIsProfileFocused(true)}
    onBlur={() => setIsProfileFocused(false)}
    classNamePrefix="react-select"
    isClearable
  />
</div>
        <div className={`feedbackform ${formErrors.interviewerName ? 'did-error-input' : ''}`}>

          <input
            type="text" className="feedbackform-input-div"
            name="interviewerName" placeholder=" "
            value={formData.interviewerName}
            onChange={handleInputChange}
            required
          />
          <label className="feedbackform-label">Interviewer&nbsp;Name</label>
        </div>
        <div className={`feedbackform ${formErrors.interviewerMarks ? 'did-error-input' : ''}`}>

          <input name="interviewerMarks" placeholder=" " className="feedbackform-input-div" type="number" value={formData.interviewerMarks} onChange={handleInputChange} required />
          <label className="feedbackform-label"> Interviewer&nbsp;Marks</label>
        </div>
        <div className="feedbackform-input-check">
          <label>Skill&nbsp;Set:</label>
          <div className="check-box">
            {skillsList.map(skill => {
              const skillKey = skill.toLowerCase();
              const isSelected = selectedSkills.some(s => s.skillName === skillKey);
              const currentRating = selectedSkills.find(s => s.skillName === skillKey)?.rating || 1;

              return (
                <div key={skill} style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
                  <label>
                    <input
                      type="checkbox"
                      name="skills"
                      value={skill}
                      checked={isSelected}
                      onChange={handleSkillChange}
                    />{" "}
                    {skill}
                  </label>

                  {/* Always show slider but disable it unless checkbox is checked */}
                  <div style={{ display: "inline-block", marginLeft: "15px", verticalAlign: "middle" }}>
                    <input
                      type="range"
                      min="1"
                      max="10"
                      value={currentRating}
                      disabled={!isSelected} // 👈 This disables the slider unless checkbox is selected
                      onChange={(e) => handleRatingChange(skillKey, Number(e.target.value))}
                      style={{
                        width: "200px",
                        marginRight: "10px",
                        verticalAlign: "middle",
                        opacity: isSelected ? 1 : 0.5, // visual cue when disabled
                        cursor: isSelected ? "pointer" : "not-allowed"
                      }}
                    />
                    <span>{currentRating}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>


        <div className={`feedbackform ${formErrors.remarks ? 'did-error-input' : ''}`}>

          <input className="feedbackform-input-div" placeholder="" name="remarks" value={formData.remarks} onChange={handleInputChange} />
          <label className="feedbackform-label">Remarks</label>
        </div>
        <div className="feedbackform-input-label-content-select">
          <label className={`did-floating-label-select ${isStatusFloated ? 'label-float-select' : ''}`}><span className="label-text">Status:</span></label>

           <Select
            placeholder=""
            options={statusOptions}
            value={statusOptions.find(option => option.value === formData.status) || null}
            onChange={handleStatusChange}
              onFocus={() => setIsStatusFocused(true)}
              onBlur={() => setIsStatusFocused(false)}
                classNamePrefix="react-select"
            isClearable
          />

        </div>
        <button
          className="submit-btn"
          type="submit"
          disabled={!isFormValid()}
          style={{
            backgroundColor: isFormValid() ? "#007BFF" : "#ccc",
            cursor: isFormValid() ? "pointer" : "not-allowed"
          }}
        >
          Submit
        </button>

      </form>
    </div>
  );
};

export default Feedbackform;
